import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useRef } from 'react';
import WrapperButton from '../../../components/buttons/WrapperButton';
import { useQuery } from '@tanstack/react-query';
import { fetchPolicyAttachment } from '../../../services/Insurance/Policy';
import { ApiError } from '../../../Interfaces/system/Generic.interfaces';
import ErrorToast, { showToast } from '../../../components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';
import { downloadFile } from '@/src/utils/fileUtil';

type PolicyAttachmentProps = {
  policyID: string;
  attachmentName?: string;
  showIcon?: boolean;
};

const PolicyAttachment = ({
  policyID,
  attachmentName,
  showIcon,
}: PolicyAttachmentProps) => {
  const toast = useRef<Toast>(null);

  const { isFetching, refetch } = useQuery({
    queryKey: ['getPolicyAttachments', policyID],
    queryFn: ({ signal }) => fetchPolicyAttachment(policyID, signal),
    refetchOnWindowFocus: false,
    enabled: false,
    onSuccess: (data) => {
      downloadFile(data, attachmentName);
    },
    onError: (error: ApiError) => {
      const errorMessage = error.response?.data?.message;
      showToast(
        'error',
        toast,
        'Download Error',
        errorMessage ??
          `Couldn't download the attachment! Please try again later.`,
        3000
      );
    },
  });

  if (showIcon) {
    return (
      <div>
        <ErrorToast toastRef={toast} />
        {isFetching && <ProgressSpinner className="w-1rem h-auto" />}
        {!isFetching && (
          <WrapperButton onClick={(e) => refetch()}>
            <i className="pi pi-paperclip totalColor" />
          </WrapperButton>
        )}
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorToast toastRef={toast} />
      <label htmlFor="notes" className="text-18px block mb-2 font-bold">
        Attachment:
      </label>
      <div>
        {isFetching && <ProgressSpinner className="w-1rem h-auto" />}
        {!isFetching && (
          <WrapperButton
            className={attachmentName ? 'totalColor' : 'blackText'}
            onClick={attachmentName ? () => refetch() : undefined}
            disabled={!attachmentName}
          >
            {attachmentName ?? '-'}
          </WrapperButton>
        )}
      </div>
    </React.Fragment>
  );
};

export default PolicyAttachment;
